import main from '../shared/main.js';

export default main('Window', true);
